import { type Biome } from '@goodtime/shared';
import { KingdomForegroundEffects } from './KingdomForegroundEffects';

export interface BiomeForegroundEffectsProps {
  biomeId: Biome['id'];
  /** Total width of the L1 strip in pixels (varies by biome based on
   * node count + portal reservations). Effects that travel across the
   * whole world (butterflies, tumbleweed) need this to compute their
   * X range. */
  worldWidth: number;
}

/**
 * L1 (foreground) idle effects dispatcher.
 *
 * <p>Mounted inside the L1 scrollable inner div in {@code WorldMapV2},
 * so children scroll at 1.0× — they look like sprites that live in the
 * same plane as the node platforms. Coordinates here are pixel-based
 * in the L1 native coordinate system (0..worldWidth horizontally).
 */
export function BiomeForegroundEffects({
  biomeId,
  worldWidth,
}: BiomeForegroundEffectsProps) {
  switch (biomeId) {
    case 'kingdom':
      return <KingdomForegroundEffects worldWidth={worldWidth} />;
    default:
      return null;
  }
}
